import AboutUs from "@/pages/landing/AboutUs";
import BlogTwo from "@/pages/landing/BlogTwo";
import Contact from "@/pages/landing/Contact";
import Countries from "@/pages/landing/Countries";
import Faqs from "@/pages/landing/Faqs";
import Fees from "@/pages/landing/Fees";
import HelpCenter from "@/pages/landing/HelpCenter";
import HelpCenter2 from "@/pages/landing/HelpCenter2";
import HelpCenterDetails from "@/pages/landing/HelpCenterDetails";
import HowWorks from "@/pages/landing/HowWorks";
import MarketingHome from "@/pages/landing/Home";
import MarketingHomeEight from "@/pages/landing/HomeEight";
import MarketingHomeEleven from "@/pages/landing/HomeEleven";
import MarketingHomeFive from "@/pages/landing/HomeFive";
import MarketingHomeFour from "@/pages/landing/HomeFour";
import MarketingHomeNine from "@/pages/landing/HomeNine";
import MarketingHomeSeven from "@/pages/landing/HomeSeven";
import MarketingHomeSix from "@/pages/landing/HomeSix";
import MarketingHomeTen from "@/pages/landing/HomeTen";
import MarketingHomeThree from "@/pages/landing/HomeThree";
import MarketingHomeTwo from "@/pages/landing/HomeTwo";
import OurTeam from "@/pages/landing/OurTeam";
import PrivacyPolicy from "@/pages/landing/PrivacyPolicy";
import Reviews from "@/pages/landing/Reviews";
import NotFoundPage from "@/pages/NotFound";
import MarketingLayout from "@/layouts/MarketingLayout";
import RootLayout from "@/layouts/RootLayout";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const ROUTER_FUTURE = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

export default function App() {
  return (
    <BrowserRouter future={ROUTER_FUTURE}>
      <Routes>
        <Route element={<RootLayout />}>
          <Route element={<MarketingLayout />}>
            <Route index element={<MarketingHome />} />
            <Route path="index-2" element={<MarketingHomeTwo />} />
            <Route path="index-3" element={<MarketingHomeThree />} />
            <Route path="index-4" element={<MarketingHomeFour />} />
            <Route path="index-5" element={<MarketingHomeFive />} />
            <Route path="index-6" element={<MarketingHomeSix />} />
            <Route path="index-7" element={<MarketingHomeSeven />} />
            <Route path="index-8" element={<MarketingHomeEight />} />
            <Route path="index-9" element={<MarketingHomeNine />} />
            <Route path="index-10" element={<MarketingHomeTen />} />
            <Route path="index-11" element={<MarketingHomeEleven />} />
            <Route path="blog" element={<BlogTwo />} />
            <Route path="help-center" element={<HelpCenter />} />
            <Route path="help-center-2" element={<HelpCenter2 />} />
            <Route path="help-center-details" element={<HelpCenterDetails />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="contact" element={<Contact />} />
            <Route path="countries" element={<Countries />} />
            <Route path="faqs" element={<Faqs />} />
            <Route path="fees" element={<Fees />} />
            <Route path="how-works" element={<HowWorks />} />
            <Route path="our-team" element={<OurTeam />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="reviews" element={<Reviews />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
